import React, { useState } from 'react';
import BetResponseModal from './BetResponseModal';

function BetResponseList({ bets, onResponseSubmitted, currentUserEmail }) {
  const [selectedBet, setSelectedBet] = useState(null);

  const handleOpenModal = (bet) => {
    setSelectedBet(bet);
  };

  const handleCloseModal = () => {
    setSelectedBet(null);
  };

  return (
    <div>
      {bets.length > 0 ? (
        <ul className="BetList">
          {bets.map((bet) => (
            <li key={bet.id} className="BetList-item">
              <p><strong>Bet:</strong> {bet.description}</p>
              <p><strong>Who called the round:</strong> {bet.creator_name}</p>
              <p><strong>Creator's Prediction:</strong> {bet.creator_prediction}</p>
              <button onClick={() => handleOpenModal(bet)}>
                Make Your Prediction
              </button>
            </li>
          ))}
        </ul>
      ) : (
        <p>No bets waiting for your response.</p>
      )}

      {selectedBet && (
        <BetResponseModal
          bet={selectedBet}
          onClose={handleCloseModal}
          onResponseSubmitted={onResponseSubmitted}
          currentUserEmail={currentUserEmail}
        />
      )}
    </div>
  );
}

export default BetResponseList;
